// FLAGS: none
// OpenUp logo image.
import OpenUpLogoSrc from "./openup_logo.svg?url";

const OpenUp = ({ className }) => (
  <img className={className} src={OpenUpLogoSrc} alt="The OpenUp logo" />
);

export default OpenUp;
